export const useSustainableDevelopment = () => {

  const { t } = useI18n()

  const chainOfValues = [
    {
      text: 'responsibleBusiness.businessModel.chain[0].text',
      textCustom: 'responsibleBusiness.businessModel.chain[0].textCustom',
      color: '#BA8BF5',
      boxes: [
        {
          items: [
            {
              img: {
                url: '/icons/icon-organic.svg',
              },
              text: 'responsibleBusiness.businessModel.chain[0].boxes[0].items[0].text',
            },
            {
              img: {
                url: '/icons/filter-organization-1.svg',
              },
              text: 'responsibleBusiness.businessModel.chain[0].boxes[0].items[1].text',
            },
            {
              img: {
                url: '/icons/icon-laptop.svg',
              },
              text: 'responsibleBusiness.businessModel.chain[0].boxes[0].items[2].text',
            },
            {
              img: {
                url: '/icons/icon-crowd.svg',
              },
              text: 'responsibleBusiness.businessModel.chain[0].boxes[0].items[3].text',
            },
          ],
        },
      ],
    },
    {
      text: 'responsibleBusiness.businessModel.chain[1].text',
      textCustom: 'responsibleBusiness.businessModel.chain[1].textCustom',
      color: '#9C5BEF',
      boxes: [
        {
          items: [
            {
              img: {
                url: '/icons/icon-globe.svg',
              },
              text: 'responsibleBusiness.businessModel.chain[1].boxes[0].items[0].text',
            },
            {
              img: {
                url: '/icons/icon-pin.svg',
              },
              text: 'responsibleBusiness.businessModel.chain[1].boxes[0].items[1].text',
            },
          ],
        },
        {
          items: [
            {
              img: {
                url: '/icons/icon-nodes.svg',
              },
              text: 'responsibleBusiness.businessModel.chain[1].boxes[1].items[0].text',
            },
            {
              img: {
                url: '/icons/icon-nodes-1.svg',
              },
              text: 'responsibleBusiness.businessModel.chain[1].boxes[1].items[1].text',
            },
            {
              img: {
                url: '/icons/icon-nodes-2.svg',
              },
              text: 'responsibleBusiness.businessModel.chain[1].boxes[1].items[2].text',
            },
          ],
        },
      ],
    },
    {
      text: 'responsibleBusiness.businessModel.chain[2].text',
      textCustom: 'responsibleBusiness.businessModel.chain[2].textCustom',
      color: '#7C49BE',
      boxes: [
        {
          items: [
            {
              img: {
                url: '/icons/icon-hexagon-user.svg',
              },
              text: 'responsibleBusiness.businessModel.chain[2].boxes[0].items[0].text',
            },
            {
              img: {
                url: '/icons/icon-recycle.svg',
              },
              text: 'responsibleBusiness.businessModel.chain[2].boxes[0].items[1].text',
            },
          ],
        },
      ],
    },
  ]

  const significanceMatrixClimateChange =
  {
    header: t('sustainableDevelopment.significanceMatrix.list1.title'),
    label: {
      type: 'environmental',
      key: 'E1',
    },
    items:
      [
        [
          {
            text: t('sustainableDevelopment.significanceMatrix.list1.item2'),
          },
          {
            text: t('sustainableDevelopment.significanceMatrix.list1.item3'),
          },
        ],
      ],
  }

  const significanceMatrixOwnEmployeeResources =
  {
    header: t('sustainableDevelopment.significanceMatrix.list2.title'),
    label: {
      type: 'social',
      key: 'S1',
    },
    items:
      [
        [
          {
            text: t('sustainableDevelopment.significanceMatrix.list2.item1'),
          },
          {
            text: t('sustainableDevelopment.significanceMatrix.list2.item2'),
          },
        ],
      ],
  }

  const significanceMatrixAffectedCommunities =
  {
    header: t('sustainableDevelopment.significanceMatrix.list6.title'),
    label: {
      type: 'social',
      key: 'S3',
    },
    items:
      [
        [
          {
            text: t('sustainableDevelopment.significanceMatrix.list6.item1'),
          },
        ],
      ],
  }

  const significanceMatrixConsumersAndEndUsers =
  {
    header: t('sustainableDevelopment.significanceMatrix.list4.title'),
    label: {
      type: 'social',
      key: 'S4',
    },
    items:
      [
        [
          {
            text: t('sustainableDevelopment.significanceMatrix.list4.item1'),
          },
          {
            text: t('sustainableDevelopment.significanceMatrix.list4.item2'),
          },
          {
            text: t('sustainableDevelopment.significanceMatrix.list4.item3'),
          },
        ],
      ],
  }

  const significanceMatrixBusinessConduct =
  {
    header: t('sustainableDevelopment.significanceMatrix.list5.title'),
    label: {
      type: 'governance',
      key: 'G1',
    },
    items:
      [
        [
          {
            text: t('sustainableDevelopment.significanceMatrix.list5.item1'),
          },
        ],
      ],
  }
  return {
    chainOfValues,
    significanceMatrixClimateChange,
    significanceMatrixOwnEmployeeResources,
    significanceMatrixConsumersAndEndUsers,
    significanceMatrixBusinessConduct,
    significanceMatrixAffectedCommunities,
  }
}
